import { all, takeLatest, call, put } from 'redux-saga/effects';
import actions from './actions';
import { SERVER_ERRORS } from '../../../../api/SERVER_ERRORS';
import { fetchDocuments } from '../../../../api/documents/documents.api';
import notifications from '../../notification/actions';

function* fetchSupportDocuments() {
    try {
        const data = yield call(fetchDocuments);
        if (data.docs) {
            yield put({
                type: actions.FETCH_SUPPORT_DOCUMENTS_SUCCESS,
                docs: data.docs,
            });
        } else {
            yield put(notifications.createNotification({
                ...data[0],
                mainAction: actions.FETCH_SUPPORT_DOCUMENTS_ERROR,
            }));
        }
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.FETCH_SUPPORT_DOCUMENTS_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(actions.FETCH_SUPPORT_DOCUMENTS, fetchSupportDocuments),
    ]);
}
